import script from "./PasswordInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordInput.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordInput.vue?vue&type=style&index=0&id=2de42ffc&lang=scss"

const __exports__ = script;

export default __exports__